import { createContext } from "react";
 
export const adminContext = createContext({
    toggel : true,
    setToggel : ()=>{},
     page : "",
     setPage: ()=>{},
  
})